/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Retail {
    import fld = POSSalesItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class POSSalesItemsBOMEditor extends _Ext.BOMGridEditor<POSSalesItemsBOMRow> { 
        protected getDialogType() { return POSSalesItemsBOMDialog; }
        protected getLocalTextPrefix() { return POSSalesItemsBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSSalesItemsDialog).CalculateTotals();
                }
            });
        } 

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
         
    }
}